<template>
  <div
    class="signin d-flex flex-column justify-content-center align-items-center h-100 p-4"
  >
    <div class="logo-container d-flex flex-row justify-content-center">
      <HeaderLogo class="mx-auto" />
    </div>
    <form
      class="login-form p-4 mt-5 p-sm-5 w-100 text-black"
      @submit="sendLink($event)"
    >
      <span
        v-if="this.config.appointmentRequestNewPatientEnable"
        class="backButton"
        @click="goBack"
        style="width: 600px"
      >
        <i class="fas fa-angle-left mr-1"></i> Back
      </span>
      <div class="d-flex flex-column justify-content-between text-center">
        <div class="d-flex justify-content-center text-center">
          <img
            class="secondary-logo pb-3"
            :src="this.config ? this.config.organizationLogo : ''"
            alt=""
          />
        </div>
        <div class="d-flex flex-column mb-4">
          <h3>{{ $t("login.title") }}</h3>
        </div>
        <div v-if="!loading && !emailSended" class="d-flex flex-column mb-4">
          <small class="mb-2"> {{ $t("login.subtitle") }} </small>
          <b-form-group class="mx-sm-5">
            <b-form-input
              :placeholder="translate.email"
              v-model="email"
              type="email"
              class="auth-input bigger-input"
              required
            />
          </b-form-group>
        </div>
      </div>

      <div
        v-if="loading"
        class="d-flex flex-column align-items-center mt-4 mb-4"
      >
        <b-spinner
          style="width:4rem; height:4rem;"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>

      <div
        v-if="!loading && !emailSended"
        class="d-flex flex-row justify-content-center"
      >
        <button class="btn btn-primary px-5" type="submit">
          {{ $t("login.sendLink") }}
        </button>
      </div>

      <b-alert
        v-model="alert.show"
        :variant="alert.variant"
        class="text-center mt-3 mb-0"
      >
        {{ alert.message }}
      </b-alert>

      <select-language class="lang-select" />
    </form>
  </div>
</template>

<script>
import { i18n } from "../../config/languages/i18n";
import SelectLanguage from "../../views/SelectLanguage.vue";
import AuthService from "../../server/auth";
import HeaderLogo from "../../views/HeaderLogo.vue";
import { mapState } from "vuex";

export default {
  name: "SignIn",
  components: { HeaderLogo, SelectLanguage },
  data() {
    return {
      loading: false,
      alert: {
        show: false,
        variant: "success",
        message: "Hola"
      },
      emailSended: false,
      email: ""
    };
  },
  methods: {
    goBack() {
      this.$router.push("/welcome");
    },
    sendLink(evt) {
      evt.preventDefault();
      this.loading = true;
      this.alert.show = false;
      AuthService.sendLink(this.email)
        .then(() => {
          this.alert = {
            show: true,
            variant: "success",
            message: this.$t("login.linkSent")
          };
          this.emailSended = true;
        })
        .catch(() => {
          this.alert = {
            show: true,
            variant: "success",
            message: this.$t("login.linkSent")
          };
          this.emailSended = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    newLanguage() {
      this.$i18n.locale = "es";
      i18n.locale = "es";
    }
  },
  computed: {
    ...mapState("session", {
      config: state => state.systemSettings
    }),
    translate() {
      return {
        email: this.$t("login.email")
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.secondary-logo {
  height: 100px;
}

.backButton {
  cursor: pointer;
  color: #208de2;
  font-size: 18px;
}
.signin {
  position: relative;
  background: linear-gradient(
    to bottom,
    #13609b,
    #208de2 47.5%,
    #f5f6f9 47.5%,
    #f5f6f9
  );

  .logo-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, calc(-50% - 235px));
  }
}

.login-form {
  max-width: 575px;

  .lang-select {
    float: left;
    font-size: 0.7em;
    max-width: 100px;
    margin-top: 2em;
  }

  input {
    font-size: 0.8em;
  }
}
</style>
